import React from "react"

function IconChecklist({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="checklist"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-checklist"
      {...props}
    >
      <path
        d="M10.513 14.143c.24.213.287.564.126.829l-.07.095-4.513 5.09a.655.655 0 0 1-.892.083l-.084-.078-2.293-2.545a.655.655 0 0 1 .885-.957l.087.08 1.802 2L9.59 14.2a.655.655 0 0 1 .924-.056zm8.542 4.417a.655.655 0 0 1 .106 1.3l-.106.01h-5.6a.655.655 0 0 1-.107-1.301l.107-.009h5.6zm1.527-3.564a.655.655 0 0 1 .106 1.3l-.106.01h-7.127a.655.655 0 0 1-.107-1.301l.107-.009h7.127zM10.512 4.092c.241.213.288.564.127.829l-.07.095-4.513 5.09a.655.655 0 0 1-.892.083l-.084-.078-2.293-2.545a.655.655 0 0 1 .885-.957l.087.08L5.56 8.69 9.59 4.148a.655.655 0 0 1 .924-.056zm8.543 4.417a.655.655 0 0 1 .106 1.3l-.106.01h-5.6a.655.655 0 0 1-.107-1.301l.107-.009h5.6zm1.527-3.564a.655.655 0 0 1 .106 1.301l-.106.009h-7.127a.655.655 0 0 1-.107-1.301l.107-.009h7.127z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconChecklist
